var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.343 3.47514L13.4091 7.40906L13.9394 10.0607L16.5911 10.591L20.525 6.65712L20.5254 6.65695C21.0123 7.80636 21.1288 9.07897 20.8585 10.2977C20.5883 11.5164 19.9448 12.6205 19.0177 13.4563C18.0906 14.2922 16.9259 14.8182 15.6859 14.9612C14.4458 15.1041 13.192 14.8569 12.099 14.2539L12.0991 14.2537L6.84106 20.341C6.41902 20.7626 5.84685 20.9993 5.25034 20.9991C4.65382 20.999 4.08179 20.7619 3.65999 20.3401C3.23819 19.9183 3.00115 19.3463 3.00098 18.7498C3.00081 18.1533 3.23752 17.5811 3.65908 17.1591L9.7464 11.9011L9.74627 11.9011C9.14326 10.8081 8.89603 9.55434 9.03897 8.31427C9.18191 7.07419 9.70793 5.90953 10.5438 4.98241C11.3796 4.05528 12.4838 3.41182 13.7025 3.1416C14.9211 2.87137 16.1938 2.98783 17.3432 3.47475L17.343 3.47514Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.ce43e758.svg";
export { ForwardRef as ReactComponent };